import { createStyles, makeUiStyles, Theme } from '../../../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  processBox: {
    borderBottom: `1px solid ${theme.variables.isDarkTheme ? theme.color.greys[20] : theme.color.greys[15]}`,
    padding: '24px 0',
    position: 'relative',
  },

  processBoxFirst: {
    borderBottom: `1px solid ${theme.variables.isDarkTheme ? theme.color.greys[20] : theme.color.greys[15]}`,
    padding: '0 0 24px',
    position: 'relative',
  },

  processBoxLast: {
    padding: '24px 0 0',
    position: 'relative',
  }
}), { name: 'ProcessBox', index: StylesIndexInjections.UI_ATOMS });
